<template>
  <div class="cardinar-video__container">
    <video
      muted
      loop
      playsinline
      autoplay
      class="cardinar__video"
      :src="posterVideo"
      type="video/mp4"
    />
    <div class="cardinar-video__filter"></div>
  </div>
</template>

<script>
export default {
  props: ["posterVideo"],
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style lang="scss">
.cardinar-video__container {
  position: relative;

  width: 100%;
  padding-top: 56.25%;

  overflow: hidden;
}
.cardinar__video {
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  object-fit: cover;
  object-position: top center;
}

.cardinar-video__filter {
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  background-color: #00000088;
}

@media screen and (orientation: portrait) {
  .cardinar-video__container {
    height: 70vw;
  }
}
</style>
